import { useSelector } from 'react-redux';

import {
  Button,
  DrawerButtonGroup,
  VStack,
  Text,
  Tooltip,
} from '@frontend/legacy-components';
import { formatConjunctionWithAnd } from '@frontend/utils';

import { formatPrice } from 'utils/formatters';
import { pluralize, pluralizeWithoutCount } from 'utils/stringUtils';

import { useCreateOrder } from '../data/hooks';
import {
  getAreAdjustmentsAndAdditionalChargesValid,
  getNumberOfSelectedParts,
  getSubtotalCost,
  getIsSettingOptions,
  getFieldErrors,
  getQuoteItems,
} from '../data/reducer';

const PartSelectionFooter = () => {
  const fieldErrors = useSelector(getFieldErrors);
  const quoteItems = useSelector(getQuoteItems);
  const areAdjustmentsAndAdditionalChargesValid = useSelector(
    getAreAdjustmentsAndAdditionalChargesValid,
  );
  const isSettingOptions = useSelector(getIsSettingOptions);
  const numberOfSelectedParts = useSelector(getNumberOfSelectedParts);
  const subTotal = useSelector(getSubtotalCost);

  const create = useCreateOrder();

  const isSaveDisabled =
    numberOfSelectedParts === 0 || !areAdjustmentsAndAdditionalChargesValid;

  const lineItemsWithErrors = quoteItems
    .filter((item) => fieldErrors[item.id])
    .map((item) => String(quoteItems.indexOf(item) + 1));

  const tooltipLabel =
    numberOfSelectedParts === 0
      ? 'Please select at least one part'
      : `All fields on line ${pluralizeWithoutCount(
          'item',
          lineItemsWithErrors.length,
        )} ${formatConjunctionWithAnd(lineItemsWithErrors)} must be filled`;

  return (
    <DrawerButtonGroup width="100%" justifyContent="space-between">
      <VStack spacing={0} alignItems="flex-start">
        <Text
          textTransform="uppercase"
          fontSize="sm"
          lineHeight="sm"
          fontWeight="heavy"
          color="feature.secondary"
        >
          {`${pluralize('Part', numberOfSelectedParts)} in Order`}
        </Text>
        <Text fontSize="md" fontWeight="bold" lineHeight="sm">
          {numberOfSelectedParts === 0
            ? '--'
            : `${formatPrice(subTotal || 0, 2)} Subtotal`}
        </Text>
      </VStack>
      <Tooltip isDisabled={!isSaveDisabled} label={tooltipLabel}>
        <Button
          variant="primary"
          isDisabled={isSaveDisabled}
          isLoading={isSettingOptions}
          onClick={create}
        >
          Continue to Shipping & Payment
        </Button>
      </Tooltip>
    </DrawerButtonGroup>
  );
};

export default PartSelectionFooter;
